/** @flow */
import * as React from 'react';

import { translate } from 'react-i18next';
import styled, { withTheme } from 'styled-components';
import { connect } from 'react-redux';

import Page from 'statsradio/components/page/Page';

import Permissions from 'statsradio/modules/authorisation/Permissions';
import AuthorisedComponent from 'statsradio/modules/authorisation/AuthorisedComponent';
import Radio from 'common/domain/radio';
import PropositionSummaryCard from 'statsradio/modules/salesDashboard/components/PropositionSummary/PropositionSummaryCard';
import { getCurrentRadio, getToken } from '../authentication/session/selectors/sessionSelectors';
import LastSyncTime from './components/LastSyncTime';
import type { SalesMemberDropdownSelectionType } from '../salesMembers/components/SalesMembersDropdown';
import SalesMembersDropdown, { SalesMemberDropdownSelection } from '../salesMembers/components/SalesMembersDropdown';
import type { SalesMember } from '../salesMembers/domain/SalesMember';
import CampaignsToLinkCard from './components/campaignsToLink/CampaignsToLinkCard';
import LinkedCampaignsCard from './components/linkedCampaigns/LinkedCampaignsCard';

const Row = styled.div`
  padding: 0;
  margin: ${({ theme }) => theme.V2.metrics.margin.normal}px 0;
`;

const Header = styled(Row)`
  width: 100%;
  align-items: center;
  padding: 0;
`;

const Column = styled.div`
  padding: 0;
`;
const LastSyncTimeWrapper = styled(Column)`
  display: flex;
  justify-content: flex-end;
`;

const StyledCampaignsToLinkCard = styled(CampaignsToLinkCard)`
  margin: ${({ theme }) => theme.V2.metrics.margin.small}px;
`;

const StyledPropositionSummaryCard = styled(PropositionSummaryCard)`
  margin-top: ${({ theme }) => theme.V2.metrics.margin.small}px;
`;

const StyledLinkedCampaignsCard = styled(LinkedCampaignsCard)`
  margin: ${({ theme }) => theme.V2.metrics.margin.small}px;
`;

type Props = {
  t: any,
  token: string,
  radio: Radio,
};

type State = {
  selectedSalesMember?: SalesMember,
}

class SalesDashboardPage extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);

    this.state = {
      selectedSalesMember: undefined,
    };
  }

  componentDidUpdate(prevProps: Props): void {
    const { radio } = this.props;
    if (!prevProps.radio.isSame(radio)) {
      this.resetSalesMemberFilter();
    }
  }

  resetSalesMemberFilter = () => {
    this.setState({ selectedSalesMember: undefined });
  };

  onSalesMemberChanged = (selection: SalesMemberDropdownSelectionType, member?: SalesMember) => {
    if (selection === SalesMemberDropdownSelection.SELECTED_ALL) {
      this.setState({ selectedSalesMember: undefined });
    } else {
      this.setState({ selectedSalesMember: member });
    }
  };

  render() {
    const { t, token, radio } = this.props;
    const { selectedSalesMember } = this.state;

    return (
      <Page useThemeV2 title={t('salesmanDashboard')}>
        <Header className="row">
          <AuthorisedComponent permissions={Permissions.ACCESS_SALES_MANAGEMENT}>
            <Column className="col-xs-3">
              <SalesMembersDropdown
                selectedMember={this.state.selectedSalesMember}
                onSelectMembers={this.onSalesMemberChanged}
              />
            </Column>
          </AuthorisedComponent>
          <LastSyncTimeWrapper className="col-xs-9">
            <LastSyncTime token={token} radio={radio} />
          </LastSyncTimeWrapper>
        </Header>
        <Row className="row">
          <Column className="col-xs-4">
            <StyledPropositionSummaryCard selectedSalesMember={selectedSalesMember} />
          </Column>
          <Column className="col-xs-8">
            {radio.hasConnectors &&
            <React.Fragment>
              <StyledCampaignsToLinkCard selectedSalesMember={selectedSalesMember} />
              <StyledLinkedCampaignsCard selectedSalesMember={selectedSalesMember} />
            </React.Fragment>
            }
          </Column>
        </Row>
      </Page>
    );
  }
}

function mapStateToProps(state) {
  return {
    radio: getCurrentRadio(state),
    token: getToken(state),
  };
}


export default withTheme(translate('salesDashboard')(connect(mapStateToProps, null)(SalesDashboardPage)));




// WEBPACK FOOTER //
// ./src/statsradio/modules/salesDashboard/SalesDashboardPage.js